import React from 'react'

import { ProjectEditContainer } from 'modules/ProjectEdit/containers'
import { Layout } from 'components'

const ProjectEditPage = () => (
  <Layout>
    <div className="sbx-row sbx-row-gutter-20">
      <div className="sbx-col-xs-22 sbx-col-offset-xs-1">
        <ProjectEditContainer />
      </div>
    </div>
  </Layout>
)

export default ProjectEditPage
